"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSHandler = void 0;
const StoryNodeDisplayType_1 = require("../../../../storyV2/domain/StoryNodeDisplayType");
const TransformServiceHandlerChain_1 = require("../chain/TransformServiceHandlerChain");
const LangUtil_1 = require("../../../../cutil/LangUtil");
const Meta_1 = require("../../../../cutil/Meta");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const CustomApiTransformUtil_1 = require("../../../../storyV2/response/customApiHandler/util/CustomApiTransformUtil");
class WSHandler extends TransformServiceHandlerChain_1.Handler {
    constructor(brainClient) {
        super();
        this.brainClient = brainClient;
    }
    async process(request) {
        /// 用于处理 WS 数据，非 WS 数据，不处理
        if (!request.isWS) {
            return false;
        }
        const displayType = request.displayType;
        switch (displayType) {
            case StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE:
                const fileUrl = request.websocketFileParams?.file_url;
                if (fileUrl && !(0, is_blank_1.default)(fileUrl)) {
                    const res = await (0, LangUtil_1.tryPromise)(this.brainClient.global.request(fileUrl, request.websocketFileParams?.method || "get", request.websocketFileParams?.headers || undefined, request.websocketFileParams?.body || undefined));
                    /// 更新 response 继续处理后续内容
                    request.updateResponse(res.data);
                    //wbsocket 返回的url 那么只会是s3url
                    const result = await CustomApiTransformUtil_1.CustomApiTransformUtil.getBlobResult(request, fileUrl);
                    request.setResult(result);
                    return true;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            case StoryNodeDisplayType_1.StoryNodeDisplayType.HTML:
                if (request.websocketHtml) {
                    return false;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            case StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT:
                if (request.websocketContent) {
                    request.setResult(request.websocketContent);
                    return true;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            default:
                return false;
        }
    }
}
exports.WSHandler = WSHandler;
WSHandler.contentError = new Meta_1.Meta("WSHandler Error", "Got content faild");
